import { useState } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { Button } from 'components/common';
import { Box } from 'components/common/box';
import {
  Checkbox,
  Form,
  FormGroup,
  RichText,
  Text
} from 'components/common/form';
import { UnsavedFormChanges } from 'components/common/notifications';

const GroupSettings = connect((state) => state)(
  ({
    dispatch,
    messages,
    pageState: { group },
    serverConfig: { enableGroupInfo },
    updateGroup
  }) => {
    const [loading, setLoading] = useState(false);

    const initialValues = {
      title: group.title,
      ...(enableGroupInfo
        ? {
            infoText: group.infoText,
            infoTextEnable: group.infoTextEnable,
            infoTextTitle: group.infoTextTitle
          }
        : {})
    };

    const handleSubmit = async (values) => {
      try {
        setLoading(true);
        const response = await api.put(`/admin/groups/${group.id}`, values);

        if (!response.data || !response.data.success) throw new Error('error');

        await updateGroup();

        setLoading(false);
        dispatch(actions.updatePageState({ hasUnsavedChanges: false }));
        dispatch(
          actions.addNotice({
            text: messages.settingsSavedSuccessfully,
            type: 'success'
          })
        );
      } catch (err) {
        await dispatch.handleErrorDispatch(err);
      }
    };

    const validateTitle = async (value) => {
      if (!value || !value.trim()) return messages.commonTitleEmpty;

      try {
        await api.head(`/admin/groups?title=${value}&id=ne|${group.id}`);

        return messages.commonTitleInUse;
      } catch (err) {
        return undefined;
      }
    };

    return (
      <div className="settings">
        <Box title={messages.commonSettings}>
          <Form
            allowEmptyStrings={true}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({ formState }) => (
              <>
                <UnsavedFormChanges initialValues={initialValues} />

                <div>
                  <FormGroup htmlFor="title" label={messages.groupsGroupTitle}>
                    <Text
                      customValidateAsync={validateTitle}
                      field="title"
                      id="title"
                    />
                  </FormGroup>

                  {enableGroupInfo ? (
                    <>
                      <FormGroup
                        label={messages.groupsInfo}
                        style={{ marginTop: 30 }}
                      >
                        <Checkbox
                          field="infoTextEnable"
                          id="info-text-enable"
                          label={messages.groupsInfoTextEnable}
                        />
                      </FormGroup>

                      <FormGroup label={messages.groupsInfoTitle}>
                        <Text
                          disabled={!formState.values.infoTextEnable}
                          field="infoTextTitle"
                          id="info-text-title"
                          placeholder={group.title}
                        />
                      </FormGroup>

                      <FormGroup label={messages.groupsInfoText}>
                        <RichText
                          autoGrow={false}
                          disabled={!formState.values.infoTextEnable}
                          field="infoText"
                          id="info-text"
                          maxLength={3000}
                        />
                      </FormGroup>
                    </>
                  ) : null}

                  <FormGroup style={{ marginTop: 30 }}>
                    <Button
                      category="success"
                      disabled={formState.invalid}
                      loading={loading}
                      text={messages.commonSave}
                      type="submit"
                    />
                  </FormGroup>
                </div>
              </>
            )}
          </Form>
        </Box>
      </div>
    );
  }
);

export default GroupSettings;
